export default __webpack_public_path__ + "static/media/image12.3185b4d7.jpg";